import { render } from "./ReplyDots.vue?vue&type=template&id=456b4477"
import script from "./ReplyDots.vue?vue&type=script&lang=js"
export * from "./ReplyDots.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__